module.exports = __webpack_public_path__ + "static/media/check icon.2f74d82d.svg";